module.exports = __webpack_public_path__ + "static/media/as2tj0.0495ec95.png";